export const homePageNavItems = [
  { id: 1, label: "about me", href: "/about" },
  { id: 2, label: "projects", href: "/projects" },
  { id: 3, label: "contacts", href: "/contacts" },
];